import { render, staticRenderFns } from "./TournamentPreset.vue?vue&type=template&id=63d4ad7d&scoped=true"
import script from "./TournamentPreset.vue?vue&type=script&lang=js"
export * from "./TournamentPreset.vue?vue&type=script&lang=js"
import style0 from "./TournamentPreset.vue?vue&type=style&index=0&id=63d4ad7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4ad7d",
  null
  
)

export default component.exports